import React from 'react';
import { Link } from 'react-router-dom';
import { IndianRupee } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';

const Footer = () => {
  const footerLinks = {
    Trading: [
      { label: 'MovieStocks', href: '/securities/movies' },
      { label: 'StarBonds', href: '/securities/stars' },
      { label: 'All Securities', href: '/securities' },
    ],
    Community: [
      { label: 'Forums', href: '/forum' },
      { label: 'Leaderboards', href: '/leaderboards' },
    ],
    Account: [
      { label: 'Portfolio', href: '/portfolio' },
      { label: 'Login', href: '/login' },
      { label: 'Register', href: '/register' },
    ],
  };

  return (
    <footer className="bg-[#0A0E17] border-t border-[#1E293B]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-[#F59E0B] to-[#D97706] rounded-lg flex items-center justify-center">
                <span className="text-black font-black text-lg">B₹</span>
              </div>
              <div>
                <h1 className="text-[#F8FAFC] font-bold text-lg leading-tight font-heading">Bollywood</h1>
                <p className="text-[#F59E0B] text-xs font-semibold tracking-[0.2em]">SENSEX</p>
              </div>
            </Link>
            <p className="text-[#64748B] text-sm mb-4 max-w-sm leading-relaxed">
              India's premier virtual stock exchange for Bollywood movies and stars. Trade with virtual currency and test your box office prediction skills.
            </p>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-[#F8FAFC] font-semibold mb-4 text-sm uppercase tracking-wider">{category}</h3>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.href} className="text-[#64748B] text-sm hover:text-[#F59E0B] transition-colors">{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-[#1E293B] py-4 px-4">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#64748B] text-sm text-center md:text-left">
            {new Date().getFullYear()} Bollywood Sensex. All rights reserved. Virtual trading platform.
          </p>
          <div className="flex items-center gap-4 text-[#64748B] text-sm">
            <span>No real money involved</span>
            <span className="text-[#1E293B]">|</span>
            <span>For entertainment only</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
